import VueScrollTo from 'vue-scrollto'

export const scrollTo = VueScrollTo.scrollTo
